import { useMemo } from 'react';
import type { FieldOptionBase } from 'api/tasks';
import { useTranslate } from 'hooks/use-translation';

export const ALL_ROLES_OPTION_ID = -1;
export const useAllRolesOption = (): FieldOptionBase => {
  const translate = useTranslate();

  return useMemo(
    () =>
      ({
        label: translate('views.view_available.options.team'),
        value: ALL_ROLES_OPTION_ID,
        color: 'cool-gray',
        active: true,
      } as FieldOptionBase),
    [translate],
  );
};
